import ServiceCard from './ServiceCard';
export type { ServiceCardProps } from './ServiceCard';
export default ServiceCard;
